/*eslint-disable*/
import React from 'react'
import { Link } from 'react-router-dom';
import { Container, Grid, Segment } from 'semantic-ui-react';
const AddTitleBar = (props) => {
    return (
        <div id="dispatch_bar" style={{ overflow: 'visible' }}>
            <Container fluid className="m-0 p-0">
                <Segment className="p-2">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="d-flex justify-content-between">
                                <label className="mt-2">{props.Title}</label>
                                <div className={`mt-2 p-bold-600 ` + props.styleStatus}>{props.statusTitle}</div>
                                <form className="form-inline" action="#">
                                    {props.children}
                                    <Link to={props.LinkName} className="w3-button w3-hover-white w3-medium ml-1"><i className="fas fa-times"></i></Link>
                                </form>
                            </div>
                        </div>
                    </div>
                </Segment>
                {/* <div className="row">
                    <div className="col-sm-12">
                        <div className="d-flex justify-content-between">
                            <label className="mt-2">{props.Title}</label>
                            <div className={`mt-2 p-bold-600 ` + props.styleStatus}>{props.statusTitle}</div>
                            <form className="form-inline" action="#">
                                {props.children}
                                <Link to={props.LinkName} className="w3-button w3-hover-white w3-medium ml-1"><i className="fas fa-times"></i></Link>
                            </form>
                        </div>
                    </div>
                </div> */}
            </Container>
        </div>
    )
}

export default AddTitleBar
